import React, { useState, useEffect } from 'react';
import classes from "./UserAccount.module.css";
import { useTranslation } from 'react-i18next';
import moment from "moment-timezone";
import { useSelector } from 'react-redux';
import Lottie from 'lottie-react';
import RewardsAnimation from "../animations/rewards.json";
import * as motion from "motion/react";
import SubscriptionForMoreDaysModal from './SubscriptionForMoreDaysModal';
import SmallLoader from './Loaders/SmallLoader';
import SubLayout from './SubLayout';

const UserAccount = ({ userProfile }) => {
    const { t } = useTranslation();
    const [expireTime, setExpireTime] = useState(null);
    const { userDetails } = useSelector(state => state.persisted.userTokenSlice);

    const [modal, setModal] = useState(false);

    const calculatePackExpirationTime = () => {
        try {
            const liveTime = moment().tz("Asia/Kolkata");
            const expiryTime = moment.utc(userDetails?.next_billing_date).tz("Asia/Kolkata");
            const durationLeft = moment.duration(expiryTime.diff(liveTime));

            if (durationLeft.asMilliseconds() <= 0) {
                console.log("Pack expired");
            }
            const hours = Math.floor(durationLeft.asHours());
            const minutes = durationLeft.minutes();
            const seconds = durationLeft.seconds();

            if ([1].includes(hours)) {
                // show popup
            }
            if([3].includes(hours)){
                // show popup
            }
            if([5].includes(hours)){
                // show popup 
            }

            console.log(`Pack expires in ${hours}h ${minutes}m ${seconds}s`);
            setExpireTime(`${t('117')} ${hours}h ${minutes}m ${seconds}s`)
        } catch (error) {
            console.log(error, 'errro--');
        }
    }

    useEffect(() => {
        if (userDetails?.sub_type == "ondemand") {
            const intervalExirationTime = setInterval(() => {
                calculatePackExpirationTime();
            }, 1000);
            return () => {
                clearInterval(intervalExirationTime);
            }
        }
    }, []);

    return (
        <>
        <SubLayout>

            {/* <div className={classes.container}> */}
                <div className={classes.profile_section}>
                    <div className={classes.profile_sub_section}>
                        <div className={classes.profile_avatar}>
                            <img src={userProfile?.image ?? "/assets/images/dummy.png"} alt={userProfile?.name ?? t("1")} className={classes.avatar_image} />
                        </div>
                        <div className={classes.profile_details}>
                            <p className={classes.profile_text}>{userProfile?.name ?? t("1")}</p>
                            <p className={classes.profile_text}>{userProfile?.msisdn}</p>
                        </div>
                    </div>

                    <div className={classes.user_points_container}>
                        <div className={classes.rewards_animation}>
                            <Lottie animationData={RewardsAnimation} loop autoPlay className={classes.animation} />
                        </div>
                        <p className={classes.points}>{userProfile?.total_points} {t("2")}</p>
                    </div>
                </div>
                {userDetails?.sub_type == "ondemand" &&
                    <div className={classes.pack_info_container}>
                        {expireTime ?
                            (
                                <>
                                    <p className={classes.pack_expiration_time}>{expireTime}</p>
                                    <p className={classes.subscribe_btn_link} onClick={() => setModal(true)}>{t("116")}</p>
                                </>
                            ) : (
                                <div style={{ width: "100%", display: "grid", placeContent: "center" }}>
                                    <SmallLoader />
                                </div>
                            )}
                    </div>
                }
        </SubLayout>

            {/* </div> */}
            {modal &&
                <SubscriptionForMoreDaysModal expireTime={expireTime} setModal={setModal} />
            }
        </>

    )
}

export default UserAccount